import React from 'react';

interface HandshakeIconProps {
  size?: number;
  strokeWidth?: number;
  color?: string;
  className?: string;
}

/**
 * HandshakeIcon - SuperKonnected "connect" icon
 * - 24x24 grid
 * - strokeWidth: 1.5
 * - Rounded linecaps
 * - No fills
 */
export const HandshakeIcon: React.FC<HandshakeIconProps> = ({
  size = 24,
  strokeWidth = 1.5,
  color = 'currentColor',
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14" />
      <path d="M7 18l1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9" />
      <path d="m2 16 4 4" />
      <path d="M22 10l-4-4" />
      <path d="M18 14l-4-4" />
    </svg>
  );
};





























